'use client';
/**
 * Создаёт новый объект, выбирая в него перечисленные свойства исходного объекта
 * @param props Свойства объекта
 * @param source Исходный объект
 * @returns Объект с выбранными свойствами
 */ const pick = (source, props)=>{
    const result = {};
    for (const prop of props){
        result[prop] = source[prop];
    }
    return result;
};

export { pick };
//# sourceMappingURL=pick.js.map
